import React, { Component } from "react";
import { PENCIL } from "../../Constants/SrcImages";
import { RouteComponentProps } from "react-router";
import Datatable from "../../Constants/Datatable";
import { COLUMNS_ADMIN_GRADES } from "../../Constants/DatatableColumns";
import { Row, Col, Container, Label, Button } from "reactstrap";
import { GradesModal } from "./../../Constants/Modal";
import {validateTokenStorage} from './../../Constants/Util';
import { getGrades, putGrades, postGrades,getCycles } from "../../Constants/Services";
import { ICycles } from "./../../Constants/Interfaces";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

export interface IGradesCy {
  gr_id:string;
  gr_alias: string;
  gr_desc: string;
  cy_id:string;
  cy_desc:string;
}


interface IGradesState {
  dataGrade: IGradesCy[];
  dataCycles: ICycles[];
  formCycles:ICycles;
  formGrade: IGradesCy;
  loading: boolean;
  isOpenModalGrade: boolean;
  isOpenModalEditGrade: boolean;
  msg_error: string;
}

class Grades extends Component<RouteComponentProps<{}>, IGradesState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataGrade: [],
      dataCycles:[],
      formCycles:{
        cy_id: "",
        cy_desc: "",
      },
      formGrade: {
        gr_id: "",
        gr_alias: "",
        gr_desc: "",
        cy_id:"",
        cy_desc:"",
      },
      loading: false,
      isOpenModalGrade: false,
      isOpenModalEditGrade: false,
      msg_error: "",
    };

    this.fetchGrade = this.fetchGrade.bind(this);
    this.fetchCycle = this.fetchCycle.bind(this);
    this.handlerPostGrades = this.handlerPostGrades.bind(this);
    this.handlerPutGrades = this.handlerPutGrades.bind(this);
    this.onChangeGrade = this.onChangeGrade.bind(this);
    this.handlerModalAddgrade = this.handlerModalAddgrade.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.handlerDataEdit = this.handlerDataEdit.bind(this);
    this.handlerModalEditgrade = this.handlerModalEditgrade.bind(this);
    this.columnModalEditGrades = this.columnModalEditGrades.bind(this);
    this.setCycle = this.setCycle.bind(this);
  }

  
  async fetchCycle() {
    const response = await getCycles();
    this.setState({
      dataCycles: response,
      loading: false,
      msg_error: "",
    });
  }

  async fetchGrade() {
    const response = await getGrades();
    this.setState({
      dataGrade: response,
      loading: false,
      msg_error: "",
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchGrade();
    this.fetchCycle();
  }

  handlerPutGrades() {
    const props = this.state.formGrade;
    if (props.gr_desc.length > 0 && props.gr_alias.length > 0) {
      const body = {
        gr_id: props.gr_id,
        gr_alias: props.gr_alias,
        gr_desc: props.gr_desc,
        gr_cycle: props.cy_id
      };

      putGrades(body);
      this.setState({ isOpenModalEditGrade: false, loading: true, msg_error: "" });

      setTimeout(() => {
        this.fetchGrade();
      }, 1000);
    } else {
      this.setState({ msg_error: "Algunos campos estan vacios" });
    }
  }

  handlerPostGrades() {
    const props = this.state.formGrade;
    if (props.gr_desc.length > 0 && props.gr_alias.length > 0 && props.cy_id.length>0) {
      const body = {
        gr_alias: props.gr_alias,
        gr_desc: props.gr_desc,
        gr_cycle: props.cy_id
      };

      postGrades(body);
      this.setState({ isOpenModalGrade: false, loading: true, msg_error: "" });

      setTimeout(() => {
        this.fetchGrade();
      }, 1000);
    } else {
      this.setState({ msg_error: "Algunos campos estan vacios" });
    }
  }

  onChangeGrade(e: any) {
    this.setState({
      formGrade: {
        ...this.state.formGrade,
        [e.target.name]: e.target.value,
      },
      msg_error: "",
    });
  }

  rechargeData() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchGrade();
    }, 1000);
  }

  handlerModalAddgrade() {
    this.setState((prevState) => ({
      isOpenModalGrade: !prevState.isOpenModalGrade,
      formGrade:{
        gr_id: "",
        gr_alias: "",
        gr_desc: "",
        cy_id:"",
        cy_desc:""
      },
      msg_error:""
    }));
  }

  handlerModalEditgrade() {
    this.setState((prevState) => ({
      isOpenModalEditGrade: !prevState.isOpenModalEditGrade,
    }));
  }

  handlerDataEdit = (row: IGradesCy) => {
    this.setState({
      formGrade: row,
      isOpenModalEditGrade: true,
      msg_error:""
    });
  };

  columnModalEditGrades(cell: number, row: IGradesCy) {
    return (
      <Row>
        <Col xs={12} className="d-flex">
          <Label className="txt-underline" onClick={() => this.handlerDataEdit(row)}>
            {row.gr_id}
          </Label>
          <img className="img-status img-search" onClick={() => this.handlerDataEdit(row)} src={PENCIL} alt="" />
        </Col>
      </Row>
    );
  }

  setCycle = (cy_id,cy_desc) => {
    this.setState({
      formGrade: {
        ...this.state.formGrade,
        cy_id,
        cy_desc,
      },
    });
  };

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalGrade && (
          <GradesModal
            title="Agregar grado"
            data={props.formGrade}
            dataCycle={props.dataCycles}
            setCycle = {this.setCycle}
            isOpen={props.isOpenModalGrade}
            toggle={this.handlerModalAddgrade}
            toggleSave={this.handlerPostGrades}
            onChange={this.onChangeGrade}
            msg_error ={props.msg_error}
          />
        )}

        {props.isOpenModalEditGrade && (
          <GradesModal
            title="Editar grado"
            data={props.formGrade}
            dataCycle={props.dataCycles}
            setCycle = {this.setCycle}
            isOpen={props.isOpenModalEditGrade}
            toggle={this.handlerModalEditgrade}
            toggleSave={this.handlerPutGrades}
            onChange={this.onChangeGrade}
            msg_error ={props.msg_error}
          />
        )}

        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row className="body-margin">
                <Col sm={12} className="text-center">
                  <h3>Grados</h3>
                </Col>
                <Col sm={12} className="text-right">
                  <ClipLoader css={override} size={23} color={"#36D7B7"} loading={this.state.loading} />
                  <Button color="primary" className="mr-2" onClick={() => this.rechargeData()}>
                    Recargar
                  </Button>
                  <Button color="success" onClick={() => this.handlerModalAddgrade()}>
                    Agregar nuevo
                  </Button>
                </Col>
                <Col sm={12}>
                  <Datatable
                    data={props.dataGrade}
                    columns={COLUMNS_ADMIN_GRADES(this.columnModalEditGrades)}
                    keyProp="gr_id"
                    exportD={false}
                    searchs={true}
                    selectRows={false}
                    optionSelectRow={null}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Grades;
